import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { TRedirect } from '../../types';

const RedirectComponent: FC<TRedirect> = ({ config }) => {
  const { redirectLink } = config;
  const navigate = useNavigate();

  useEffect(() => {
    navigate(redirectLink);
  }, []);

  return null;
};

export default RedirectComponent;
